/**
 * @generated SignedSource<<e561d4f6c835a332822c3cde6d6d7856>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type SignalDetailFiles_files$data = ReadonlyArray<{
  readonly formattedSize: string;
  readonly id: string;
  readonly name: string | null;
  readonly pages: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly type: FileType | null;
  readonly " $fragmentType": "SignalDetailFiles_files";
}>;
export type SignalDetailFiles_files$key = ReadonlyArray<{
  readonly " $data"?: SignalDetailFiles_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailFiles_files">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SignalDetailFiles_files",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FilePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};
})();

(node as any).hash = "f5447ef5ddfbfd00fa9e79415ceaf388";

export default node;
